import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import ControlRow from "../utils/components/ControlRow";
import PlugInfo from "./modals/PlugInfo";
import ConfirmationModal from "../utils/components/ConfirmationModal";

import { setAlert } from "../../actions/alertActions";
import { searchModule, getPlug } from "../utils/Utils";
import Infrastructure from "../utils/classes/Infrastructure";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/chargers/OtherChargers.scss";
import signout from "../../styles/images/signout.svg";
import no_chargers from "../../styles/images/no_chargers.svg";
import evio_busy from "../../styles/images/markers/marker_evio_busy.svg";
import marker_private_chargers from "../../styles/images/markers/marker_private_chargers.svg";
import marker_private_offline_chargers from "../../styles/images/markers/marker_private_offline_chargers.svg";

class OtherChargers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      search: "",
      leavePlace: false,

      places: [],
      selectedPlace: null,
      selectedCharger: null,
      selectedPlug: null,

      modals: {
        leave: false,
        plugInfo: false,
      },
    };

    this.fetchPlaces = this.fetchPlaces.bind(this);
    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.handleOnLeavePlace = this.handleOnLeavePlace.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchPlaces();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchPlaces() {
    axios
      .get("/api/private/infrastructure/othersInfrastructure", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200)
          this.safeSetState(
            {
              places: res.data.map((p) => new Infrastructure(p)),
              loading: false,
            },
            () => {
              if (this.state.places.length > 0) {
                let idx = -1;
                if (this.state.selectedPlace)
                  idx = this.state.places.findIndex(
                    (p) => p._id === this.state.selectedPlace._id
                  );
                this.safeSetState({
                  selectedPlace:
                    idx !== -1 ? this.state.places[idx] : this.state.places[0],
                });
              } else this.safeSetState({ selectedPlace: null });
            }
          );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  parseStatus(status) {
    switch (parseInt(status)) {
      case 10: {
        return (
          <>
            <img src={marker_private_chargers} alt="" />
            <Translate value="myChargers_available" />
          </>
        );
      }
      case 20: {
        return (
          <>
            <img src={evio_busy} alt="" />
            <Translate value="myChargers_inUse" />
          </>
        );
      }
      case 40: {
        return (
          <>
            <img src={marker_private_offline_chargers} alt="" />
            <Translate value="myChargers_offline" />
          </>
        );
      }
      default:
        return "Unknown";
    }
  }

  handleOnSelect(selectedPlace) {
    this.safeSetState({
      selectedPlace,
    });
  }

  handleOnLeavePlace() {
    let leaveGroup = [];
    this.state.selectedPlace.listChargers.forEach((c) => {
      c.listOfGroups.forEach((group) => {
        if (
          group.hasOwnProperty("listOfUsers") &&
          group.listOfUsers.findIndex((u) => u.userId === this.props.userId) !==
            -1
        ) {
          leaveGroup.push(group.groupId);
        }
      });
    });

    axios
      .all(
        leaveGroup.forEach((_id) => {
          axios
            .patch(
              "/api/private/groupCSUsers/leaveGroupCSUsers",
              { _id },
              { cancelToken: new CancelToken((c) => (this.cancel = c)) }
            )
            .catch((err) =>
              this.props.setAlert(I18n.t(err.response.data.message), "danger")
            );
        })
      )
      .then(() => {
        this.safeSetState(
          {
            leavePlace: false,
          },
          () => {
            this.props.setAlert(
              I18n.t("otherChargers_leavePlaceSuccess"),
              "primary"
            );
            this.fetchPlaces();
          }
        );
      });
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return !this.state.loading ? (
      <div id="otherChargers" className="main-container">
        <div className="control-bar">
          <ControlRow
            showSearch={this.state.selectedPlace !== null}
            search={this.state.search}
            onSearchChange={(e) => searchModule.setSearch(this, e.target.value)}
            showCarousel={this.state.selectedPlace !== null}
            carousel={{
              items: this.state.places,
              selected: this.state.selectedPlace
                ? this.state.places.findIndex(
                    (i) => i._id === this.state.selectedPlace._id
                  )
                : 0,
              onSelect: this.handleOnSelect,
            }}
            buttons={[
              {
                show: this.state.selectedPlace !== null,
                label: "otherChargers_leavePlace",
                text: signout,
                onClick: () => this.safeSetState({ leavePlace: true }),
              },
            ]}
          />
        </div>
        {this.state.places.length === 0 && (
          <div className="no-places">
            <img src={no_chargers} alt="" className="back-car" />
            <p>
              <Translate value="otherChargers_noPlacesText" />
            </p>
          </div>
        )}
        {this.state.selectedPlace !== null && (
          <div className="component-container">
            <div className="table-container">
              <div className="table-header">
                <div className="row no-gutters">
                  <div className="col-12 row no-gutters titles">
                    <div className="col title">
                      <Translate value="otherChargers_charger" />
                    </div>
                    <div className="col title">
                      <Translate value="otherChargers_plug" />
                    </div>
                    <div className="col title">
                      <Translate value="otherChargers_status" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-values">
                {this.state.selectedPlace.listChargers
                  .filter((i) => searchModule.filter(this, i))
                  .map((c, k) =>
                    c.plugs.map((p) => {
                      return (
                        <div
                          key={`${c.chargerId}.${k}.${p.plugId}`}
                          className="row no-gutters"
                        >
                          <div
                            className="col-12 row no-gutters values slim"
                            onClick={() =>
                              this.safeSetState(
                                {
                                  selectedCharger: c,
                                  selectedPlug: p,
                                },
                                () => this.setModal("plugInfo", true)
                              )
                            }
                          >
                            <div className="col">{c.name}</div>
                            <div className="col">
                              <img
                                src={getPlug(p.connectorType).borderless}
                                alt=""
                              />
                            </div>
                            <div className="col">
                              <div className="status">
                                {parseInt(c.status) === 10 ? (
                                  this.parseStatus(p.status)
                                ) : (
                                  <>
                                    <img
                                      src={marker_private_offline_chargers}
                                      alt=""
                                    />
                                    <Translate value="myChargers_offline" />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
              </div>
            </div>
          </div>
        )}
        <div
          className={"notification " + (this.state.leavePlace ? "show" : "")}
        >
          <div className="info">
            <p id="info-title">
              <Translate value="otherChargers_leavePlace" />
            </p>
            <p id="info-desc">
              <Translate value="otherChargers_leavePlaceInfo" />
            </p>
          </div>
          <div className="buttons">
            <button
              type="button"
              className="secondary"
              onClick={this.handleOnLeavePlace}
            >
              <Translate value="otherChargers_continueBtn" />
            </button>
            <button
              type="button"
              onClick={() => this.safeSetState({ leavePlace: false })}
            >
              <Translate value="otherChargers_cancelBtn" />
            </button>
          </div>
        </div>

        <PlugInfo
          show={this.state.modals.plugInfo}
          onHide={() => this.setModal("plugInfo", false)}
          selectedCharger={this.state.selectedCharger}
          selectedPlug={this.state.selectedPlug}
        />

        <ConfirmationModal
          show={this.state.modals.leave}
          onHide={() => this.setModal("leave", false)}
          title="otherChargers_leaveGroup"
          body="otherChargers_leaveGroupText"
          button="otherChargers_leaveGroup"
          onConfirm={this.handleOnLeaveGroup}
        />
      </div>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.account.accountData.id,
});

export default connect(mapStateToProps, { setAlert })(OtherChargers);
